<div class="create-contact-modal">
  <form
    class="create-contact-modal__form"
    [formGroup]="formModel.form"
    (ngSubmit)="submitForm()"
  >
    <section class="create-contact-modal__panel">
      <div class="create-contact-modal__grid">
        <div class="create-contact-modal__field">
          <label for="name-input" class="form-label required">
            {{ "INPUTS.NAME" | translate }}
          </label>

          @let contactNameControl = formModel.form.controls.name;

          <input
            id="name-input"
            type="text"
            class="form-input"
            [class.is-invalid]="
              contactNameControl.touched && contactNameControl.errors
            "
            [class.is-valid]="
              contactNameControl.touched && !contactNameControl.errors
            "
            [formControlName]="formModel.fieldNames.name"
          />

          <ng-container
            [ngTemplateOutlet]="validationErrorsTemplate"
            [ngTemplateOutletContext]="{ errors: contactNameControl.errors }"
          ></ng-container>
        </div>

        <div class="create-contact-modal__field">
          <label for="surname-input" class="form-label">
            {{ "INPUTS.SURNAME" | translate }}
          </label>

          @let contactSurnameControl = formModel.form.controls.surname;

          <input
            id="surname-input"
            type="text"
            class="form-input"
            [class.is-invalid]="
              contactSurnameControl.touched && contactSurnameControl.errors
            "
            [class.is-valid]="
              contactSurnameControl.touched && !contactSurnameControl.errors
            "
            [formControlName]="formModel.fieldNames.surname"
          />

          <ng-container
            [ngTemplateOutlet]="validationErrorsTemplate"
            [ngTemplateOutletContext]="{ errors: contactSurnameControl.errors }"
          ></ng-container>
        </div>

        <div class="create-contact-modal__field">
          <label for="phone-input" class="form-label">
            {{ "INPUTS.PHONE" | translate }}
          </label>

          @let contactPhoneNumberControl = formModel.form.controls.phoneNumber;

          <input
            id="phone-input"
            type="text"
            class="form-input"
            [class.is-invalid]="
              contactPhoneNumberControl.touched &&
              contactPhoneNumberControl.errors
            "
            [class.is-valid]="
              contactPhoneNumberControl.touched &&
              !contactPhoneNumberControl.errors
            "
            [formControlName]="formModel.fieldNames.phoneNumber"
          />

          <ng-container
            [ngTemplateOutlet]="validationErrorsTemplate"
            [ngTemplateOutletContext]="{ errors: contactPhoneNumberControl.errors }"
          ></ng-container>
        </div>

        <div class="create-contact-modal__field">
          <label for="birthdate-input" class="form-label">
            {{ "INPUTS.BIRTHDATE" | translate }}
          </label>

          <input
            id="birthdate-input"
            type="date"
            class="form-input"
            [formControlName]="formModel.fieldNames.birthDate"
          />
        </div>

        <div class="create-contact-modal__field">
          <label for="email-input" class="form-label">
            {{ "INPUTS.EMAIL" | translate }}
          </label>

          @let contactEmailControl = formModel.form.controls.email;

          <input
            id="email-input"
            type="text"
            class="form-input"
            [class.is-invalid]="
              contactEmailControl.touched && contactEmailControl.errors
            "
            [class.is-valid]="
              contactEmailControl.touched && !contactEmailControl.errors
            "
            [formControlName]="formModel.fieldNames.email"
          />

          <ng-container
            [ngTemplateOutlet]="validationErrorsTemplate"
            [ngTemplateOutletContext]="{ errors: contactEmailControl.errors }"
          ></ng-container>
        </div>

        <div class="create-contact-modal__field">
          <label for="responsible-input" class="form-label required">
            {{ "INPUTS.RESPONSIBLE" | translate }}
          </label>

          <app-search
            [customClass]="'form-search-input'"
            [formControlName]="formModel.fieldNames.responsibleUserId"
            [items]="(companyEmployees$ | async) ?? []"
            [filterFn]="employeeFullNameFilter"
            [formatter]="employeeFormatter"
            [compareFn]="employeeCompareFn"
            [errorMessage]="'ERRORS.INCORRECT_SELECTED_RESPONSIBLE' | translate"
            [placeholderText]="'INPUTS.RESPONSIBLE' | translate"
            [resultTemplate]="customTemplate"
          >
            <ng-template #customTemplate let-r="result" let-t="term">
              <ngb-highlight
                class="create-contact-modal__search-name"
                highlightClass="hover-highlight"
                [result]="r?.fullName"
                [term]="t"
              ></ngb-highlight>
              <div class="create-contact-modal__search-email">{{ r?.email }}</div>
            </ng-template>
          </app-search>
        </div>

        @if (isShownOrganization) {
          <div class="create-contact-modal__field">
            <label for="organization-input" class="form-label">
              {{ "INPUTS.ORGANIZATION" | translate }}
            </label>

            <app-search
              [customClass]="'form-search-input'"
              [formControlName]="formModel.fieldNames.organizationId"
              [items]="(companyOrganizations$ | async) ?? []"
              [filterFn]="organizationSearchConfig.filterFn"
              [formatter]="organizationSearchConfig.formatter"
              [compareFn]="organizationSearchConfig.compareFn"
              [errorMessage]="'ERRORS.INCORRECT_SELECTED_ORGANIZATION' | translate"
              [placeholderText]="'INPUTS.ORGANIZATION' | translate"
            >
            </app-search>
          </div>
        }
      </div>
    </section>

    <div class="create-project-actions create-contact-modal__actions">
      <button
        type="button"
        class="form-secondary-btn"
        (click)="onCancel()"
      >
        {{ "BUTTONS.CANCEL" | translate }}
      </button>

      <button
        type="submit"
        class="form-primary-btn"
        [disabled]="formModel.form.invalid || isSubmitting"
      >
        {{ "BUTTONS.SAVE" | translate }}
      </button>
    </div>
  </form>
</div>

<ng-template #validationErrorsTemplate let-errors="errors">
  @if (errors) {
    <ul class="invalid-feedback">
      @if (errors["required"]) {
        <li>{{ "ERRORS.REQUIRED" | translate }}</li>
      }

      @if (errors["maxlength"]) {
        <li>
          {{
            "ERRORS.MAXLENGTH"
              | translate
                : { requiredLength: errors["maxlength"].requiredLength }
          }}
        </li>
      }

      @if (errors["email"]) {
        <li>{{ "ERRORS.EMAIL" | translate }}</li>
      }

      @if (errors["tel"]) {
        <li>{{ "ERRORS.PHONE" | translate }}</li>
      }
    </ul>
  }
</ng-template>
